/* eslint-disable no-nested-ternary */
export const sortBy = (key) => (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

export const getInitialSlice = (items, number) => {
  if (!items) return null;

  return items.slice(0, number);
};

export const getFour = (items) => getInitialSlice(items, 4);
